import Splide from '@splidejs/splide';
import '@splidejs/splide/dist/css/themes/splide-default.min.css';

export function blockOpinionsGfSliderScript() {
    document.addEventListener( 'DOMContentLoaded', function () {
        const opinionsGFblock = document.querySelectorAll('.reviewsgf__slider');

        opinionsGFblock.forEach(block=>{
            let opinionsGF = new Splide(block, {
                type  : 'loop',
                perPage: 2.3,
                gap: 22,
                perMove: 1,
                pagination:false,
                arrows: false,
                breakpoints: {
                    1100: { perPage: 2.1},
                    992: { perPage: 1.8 },
                    599: {  perPage: 1.1 },
                },
            });

            opinionsGF.mount()
        });
    })
}